/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Misha Kokoulin
 * @version 1.0.1
 * @since 1.0.1
 */

import { createGlobalStyle } from 'styled-components';

const SupportStyle = createGlobalStyle`
    @media all and (-ms-high-contrast: none) {
        body {
            
            /* EXT-FILTER */
            .ext-filter__value {
                /* ExtFilterValueContainerStyled */
                position: relative;
            }
            .ext-filter__value .ext-filter__clear-filter {
                /* ClearExtFilterStyled */
                position: absolute;
                right: 16px;
            }
        }
        .chart-legend_category {
            height: 100px;
        }
        .expenses-analyzer-table {
            //height: calc(100% - 300px)!important;
        }
    }
    /* TABLE */
    .table .ReactTable .rt-noData {
        display: none;
    }
    .table .table__no-data {
        position: absolute;
        transform: translateX(-50%);
        top: 130px;
        left: 50%;
    }
`;

export default SupportStyle;
